import AvWorkforceLogo from 'src/components/AvWorkforceLogo';
import { selectedHeaderPalette } from 'src/theme/adminActionButton';
import { useContext } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import { Box, Drawer, styled, useTheme } from '@mui/material';

import { useWorkspaceHeaderNavigation } from '../Header';
import { Link } from 'react-router-dom';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[100]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const { headerNavItems } = useWorkspaceHeaderNavigation();
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();

  return (
    <>
      <Drawer
        sx={{
          '--selected-border': selectedHeaderPalette.border,
          '--selected-background': selectedHeaderPalette.backgroundImage,
          '--selected-text': selectedHeaderPalette.text,
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
        className=""
      >
        <SidebarWrapper
          // sx={{
          //   background: '#ffffff'
          // }}
          className="bg-[#06070A] border-t border-white/20"
        >
          <Scrollbar>
            {/* <Box
              textAlign="center"
              style={{
                display: 'grid',
                placeItems: 'center'
              }}
            >
              <img
                alt="500"
                width={75}
                height={75}
                src="/logoIcon.png"
                style={{ objectFit: 'contain' }}
              />
            </Box> */}
            <div className="flex items-center justify-center">
              <AvWorkforceLogo width={100} height={100} />
            </div>

            <div className="relative top-2 left-0 right-0 border-t border-white/20 ">
              <nav className="p-4 space-y-2">
                {headerNavItems.map((item) => {
                  const isActive = location.pathname.startsWith(item.path);
                  const Icon = item.icon;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={toggleSidebar} // close menu after click
                      className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 text-left text-white
                    ${
                      isActive
                        ? 'border border-[var(--selected-border)] bg-[image:var(--selected-background)]'
                        : 'hover:bg-white/10'
                    }`}
                    >
                      <Icon
                        size={18}
                        className="text-white"
                      />
                      <span className="font-medium">{item.label}</span>
                    </Link>
                  );
                })}
              </nav>
            </div>
            {/* <SidebarMenu /> */}
          </Scrollbar>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
